import { Empty } from 'antd';
import React from 'react';

interface BoundryState {
  hasError: boolean;
  foundError?: Error;
}
export default class CodeSplittingErrorBoundary extends React.Component<any, BoundryState> {
  unlisten: any;

  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidUpdate() {
    const { history } = this.props;

    this.unlisten = history.listen((location: any, action: any) => {
      if (this.state.hasError) {
        this.setState({
          hasError: false,
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  componentDidCatch = (error: Error, info: any) => {
    this.setState({
      hasError: true,
      foundError: error,
    });
  };

  render() {
    if (this.state.hasError) {
      return <Empty description={'Something went wrong. Try refreshing the application or opening in a new window'} />;
    }
    return this.props.children;
  }
}
